import { useState, useEffect, useRef, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputCombo from "../../helpers/InputCombo";

import exmark from "../../exmark.png";

import back from "../../back.png";

import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Xlsx from "../../exporter/Xlsx";
import InputInteger from "../../helpers/InputInteger";
import InputPhone from "../../helpers/InputPhone";
import InputEmail from "../../helpers/InputEmail";



function CorrespForm(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [errTab, setErrTab] = useState([]); 

     const [row, setRow] = useState({

        id: -1,
        typ: '',
        typ_id: -1,
        nazwa_1: '',
        nazwa_2: '',
        ulica: '',
        nr_domu: '',
        nr_mieszkania: '',
        kod_pocztowy: '',
        miejscowosc: '',
        kraj: '',
        telefon_kontaktowy: '',
        email: '',

    });

    var tmpRow = row;



    


    const valChangeListener = (filedName, val, correct, msg) => {   
        
              
        
                //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                var tabCheck = filedName.split('@');
                if(tabCheck.length == 2)
                {
                    var tabName = tabCheck[0];
                    var tabInx  = tabCheck[1];
                    var tRef = row[tabName];
                    if(correct)tRef[tabInx] = val;
                    if(!correct)tRef[tabInx] = "";

                    tmpRow[tabName] = tRef;     
                    setRow(  JSON.parse(JSON.stringify(tmpRow)) );  
        
                    //setRowX( {...row, [tabName]:tRef } );   
                   // if(Config.env == "dev") console.log("ClientForm valChangeListner", tmpRow);
                    return;
                }
        
            
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;         


               

                setRow(  JSON.parse(JSON.stringify(tmpRow)) );    
            
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );       
                 

            }   
        
        
    const goNextNew = () => {
                console.log("goNext");               
            }



   const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }

    
    const saveData = () => {
        

        if(!valChecker(row))
        {
               
                props.mainView.showDialog("Ups!" , "Wypełnij prawidłowo pola formularza  " ,  "error"  ,null); 
                return;
        }

        
        props.mainView.showProgress();
 

        fetch( Config.url + '/rest_v1_post,corresp_set', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                
                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                         props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                props.onSuccess(res.result);  //przekaz id Firmy 
                         } );                                                  
                                                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }


    const getCorrespDet = () => {
        
    
         props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_post,corresp_det', {
            method: 'POST', 
            body: JSON.stringify( { id: props.id}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setRow(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }



    

     const keyListener = (e) => {

                        var code = e.keyCode ? e.keyCode : e.which;    
                        console.log("keylockd", e.target.nodeName, code );

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                        }else 
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {                                                           
                        }else  
                        if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                        {
                                props.onBack();                               
                        } else 
                        if( e.ctrlKey && code == 83 )   //zapisz                                               
                                {
                                       saveData();                          
                                       e.preventDefault();
                        } else 
                        {
                            props.keyListener(e);
                        }

     }


      useEffect(() => {
                                     
                if(Config.env == "dev") console.log("CorrespForm.js, listener on");
                window.onkeydown =  keyListener;

                return () => {          
                    if(Config.env == "dev") console.log("CorrespForm.js, listener off");      
                    window.onkeydown =  props.keyListener;
                };

      });
   

    if(row.id == -1 && props.id > 0)
    {
        setRow( {...row, ["id"]:-2  } );  
        getCorrespDet();
    }


    if(row.nazwa_1.length > 1)
            {
              document.title = row.nazwa_1;
            }else  document.title = 'Dane korespondenta';


    return <div className="view_content">

                {
                    props.backbtn == undefined &&
                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>
                }               

                <div className="app_header">{row.nazwa_1}</div>

                  <form className="eForm bg_center">


                        <div className="form_tab_title">Informacje podstawowe:</div>
                        <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Nazwa*</div>
                                                <InputText   userData={props.userData} value={row.nazwa_1} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa_1" placeholder={"Nazwa: np. Fortis Auto"} className=' w300 ' req='1' firstUp="1" />
                                            </div>

                                             <div className="form_split"></div>

                                             <div className="form_control">
                                                <div className="fieldName">Ulica*</div>
                                                <InputText   userData={props.userData} value={row.ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="ulica" placeholder={"Ulica: "} className=' w200 ' req='0' firstUp="0" />
                                            </div>

                                             <div className="form_control">
                                                <div className="fieldName">Nr domu*</div>
                                                <InputText   userData={props.userData} value={row.nr_domu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nr_domu" placeholder={"Nr domu: "} className=' w100 ' req='0' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Nr mieszkania*</div>
                                                <InputText   userData={props.userData} value={row.nr_mieszkania} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nr_mieszkania" placeholder={"Nr mieszkania: "} className=' w100 ' req='0' firstUp="0" />
                                            </div>


                                            <div className="form_split"></div>

                                             <div className="form_control">
                                                <div className="fieldName">Kod pocztowy*</div>
                                                <InputText   userData={props.userData} value={row.kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kod_pocztowy" placeholder={"Kod pocztowy: "} className=' w100 ' req='0' firstUp="0" />
                                            </div>

                                             <div className="form_control">
                                                <div className="fieldName">Miejscowość*</div>
                                                <InputText   userData={props.userData} value={row.miejscowosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="miejscowosc" placeholder={"Miejscowość: "} className=' w300 ' req='0' firstUp="0" />
                                            </div>


                                           <div className="form_control">
                                                <div className="fieldName">Kraj*</div>
                                                <InputText   userData={props.userData} value={row.kraj} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kraj" placeholder={"Kraj: "} className=' w200 ' req='0' firstUp="0" />
                                            </div>


                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                <div className="fieldName">Telefon</div>
                                                <InputPhone  userData={props.userData} value={row.telefon_kontaktowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="telefon_kontaktowy" placeholder={"Telefon: "} className='' req='0' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">E-mail</div>
                                                <InputEmail  userData={props.userData} value={row.email} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="email" placeholder={"E-mail: "} className='' req='0' firstUp="0" />
                                            </div>

                        </div>


                        <div className="form_split"></div>

                                <div className="form_btn">
                                        <div className="btn" onClick={saveData}>zapisz zmiany [ctrl + s ]</div>
                                        &nbsp;&nbsp;
                                        <div className="btn" onClick={props.onBack}    > anuluj [back]</div>
                        </div>


                  </form>

    </div>            


}


export default CorrespForm;

